import { memo } from 'react'

import { IIconsProps } from './icons.types'

const IconXCircle = ({ width = 20, height = 20, ...props }: IIconsProps) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width={width}
    height={height}
    viewBox='0 0 20 20'
    fill='none'
    {...props}
  >
    <g clipPath='url(#clip0_426_30189)'>
      <path
        d='M10 1.1665C14.8784 1.1665 18.8338 5.12115 18.834 9.99951C18.834 14.878 14.8785 18.8335 10 18.8335C5.12163 18.8333 1.16699 14.8779 1.16699 9.99951C1.16717 5.12125 5.12174 1.16668 10 1.1665ZM12.5889 7.41162C12.5401 7.3628 12.4609 7.36281 12.4121 7.41162L10.3535 9.46924L10 9.82275L7.58887 7.41162C7.54005 7.36281 7.46093 7.36281 7.41211 7.41162C7.36329 7.46044 7.36329 7.53956 7.41211 7.58838L9.82324 9.99951L9.46973 10.353L7.41211 12.4116C7.36329 12.4604 7.36329 12.5396 7.41211 12.5884C7.46094 12.637 7.54011 12.6371 7.58887 12.5884L9.64648 10.5298L10 10.1763L12.4121 12.5884C12.4609 12.637 12.5401 12.6371 12.5889 12.5884C12.6376 12.5396 12.6375 12.4605 12.5889 12.4116L10.1768 9.99951L10.5303 9.646L12.5889 7.58838C12.6376 7.53962 12.6375 7.46045 12.5889 7.41162Z'
        fill='#505C66'
        stroke='white'
      />
    </g>
    <defs>
      <clipPath id='clip0_426_30189'>
        <rect width='20' height='20' fill='white' />
      </clipPath>
    </defs>
  </svg>
)

export default memo(IconXCircle)
